import { render, staticRenderFns } from "./ExpandableItemBeneficiarios.vue?vue&type=template&id=616eabcd&scoped=true"
import script from "./ExpandableItemBeneficiarios.vue?vue&type=script&lang=js"
export * from "./ExpandableItemBeneficiarios.vue?vue&type=script&lang=js"
import style0 from "./ExpandableItemBeneficiarios.vue?vue&type=style&index=0&id=616eabcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616eabcd",
  null
  
)

export default component.exports